import styled from 'styled-components/macro';
import { WxButton, WxCheckbox, WxText } from '../..';
import { useCartContext } from '../../../hooks/context/useCartContext';
import { __ } from '../../../i18n/l10n';
import { breakpoint } from '../../../styles/constants';
import { splitNumber } from '../../../utils/splitNumber';

interface OrderBarProps {
  label: string;
  onClick: () => void;
  active?: boolean;
  recapCheck?: boolean;
  setRecapCheck?: (bool: boolean) => void;
}

export const OrderBar = ({
  label,
  onClick,
  active = true,
  recapCheck = false,
  setRecapCheck,
}: OrderBarProps) => {
  const {
    cart: { totalMilesAmount },
  } = useCartContext();
  return (
    <FixedWrapper>
      {setRecapCheck && (
        <RecapMobile onClick={() => setRecapCheck(!recapCheck)}>
          <WxCheckbox
            label={''}
            darkMode
            selected={recapCheck}
            onSelect={() => {}}
          />
          <WxText
            bold
            text={__('I agree for my account to be debited')}
            uppercase
            darkMode
            type={recapCheck ? 'classic' : 'alert'}
          />
        </RecapMobile>
      )}

      <DivBg>
        {setRecapCheck && (
          <Recap>
            <RowDesktop onClick={() => setRecapCheck(!recapCheck)}>
              <WxCheckbox
                darkMode
                label={''}
                onSelect={() => {}}
                selected={recapCheck}
              />
              <WxText
                darkMode
                bold
                text={__('I agree for my account to be debited')}
                uppercase
                type={recapCheck ? 'classic' : 'alert'}
              />
            </RowDesktop>
            <FlexCol>
              <WxText bold text={`Total:`} uppercase />
              <WxText
                bold
                text={`${splitNumber(totalMilesAmount)} ${__('MILES')}`}
                uppercase
              />
            </FlexCol>
          </Recap>
        )}
        <Opacity active={setRecapCheck ? recapCheck : active}>
          <WxButton
            label={label}
            onClick={onClick}
            type={'validation'}
            disabled={!active || !recapCheck}
            expand
          />
        </Opacity>
      </DivBg>
    </FixedWrapper>
  );
};

const FixedWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.darkgray};
  padding-top: 0.65rem;
  width: 100%;
`;

const DivBg = styled.div`
  clip-path: inset(0 -100vmax);
  padding-block: 0.625rem;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  @media (min-width: ${breakpoint}) {
    width: 100%;
    box-sizing: content-box;
    padding-inline: unset;
    justify-content: flex-end;
  }
`;

const Opacity = styled.div<{ active: boolean }>`
  width: 100%;
  min-width: 100px;
  pointer-events: ${({ active }) => (active ? 'default' : 'none')};

  @media (min-width: ${breakpoint}) {
    width: unset;
    min-width: 265px;
  }
`;

const Recap = styled.div`
  display: none;
  @media (min-width: ${breakpoint}) {
    display: flex;
    width: 100%;
    min-width: unset;
    justify-content: space-between;
  }
`;

const RowDesktop = styled.div`
  display: none;

  @media (min-width: ${breakpoint}) {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const RecapMobile = styled.div`
  display: flex;
  padding-inline: 1.25rem;
  height: 48px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 79.17%);

  align-items: center;
  gap: 0.625rem;

  > :first-child {
    --border-color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme }) => theme.colors.white};
  }
  @media (min-width: ${breakpoint}) {
    display: none;
  }
`;
